export const NAV_BAR_V2_TEST_ID = {
  navBar: 'nav-bar',
};
